export const SubAbasContratos = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/contratos/${id}/dadosgerais`,
  },
  {
    label: 'Destaques',
    rota: `/daf/proaq/contratos/${id}/destaques`,
  },
];

export const SubAbasContratosNovo = [
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/contratos/dadosgerais`,
  },
  // {
  //   label: 'Pautas',
  //   rota: `/daf/proaq/contratos/ficha/pautas`,
  // },
  // {
  //   label: 'Entregas',
  //   rota: `/daf/proaq/contratos/ficha/entregas`,
  // },
];
